// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLateralityIndicator_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 12 2 16 6 16 10 16 12 12 12 12 12 12 10.125 8 6 8 2 8 0 12 0 12ZM2.39254 12C2.54153 12.1873 2.7157 12.3873 2.91421 12.5858 3.69622 13.3678 4.71751 14 6 14 7.28249 14 8.30378 13.3678 9.08579 12.5858 9.2916 12.38 9.47124 12.1726 9.62379 11.9794 9.48139 11.7952 9.31392 11.5984 9.12157 11.403 8.37372 10.6433 7.35606 10 6 10 4.71751 10 3.69622 10.6322 2.91421 11.4142 2.7157 11.6127 2.54153 11.8127 2.39254 12ZM12 12C12 12 14 16 18 16 22 16 24 12 24 12 24 12 22 8 18 8 14 8 12 12 12 12ZM14.3925 12C14.5415 12.1873 14.7157 12.3873 14.9142 12.5858 15.6962 13.3678 16.7175 14 18 14 19.2825 14 20.3038 13.3678 21.0858 12.5858 21.2843 12.3873 21.4585 12.1873 21.6075 12 21.4585 11.8127 21.2843 11.6127 21.0858 11.4142 20.3038 10.6322 19.2825 10 18 10 16.7175 10 15.6962 10.6322 14.9142 11.4142 14.7157 11.6127 14.5415 11.8127 14.3925 12ZM22.2169 11.0942C22.2169 11.0942 22.2169 11.0942 22.2169 11.0942V11.0942Z" class="svg-bg"/>
  <path d="M8 12C8 13.1046 7.10457 14 6 14 4.89543 14 4 13.1046 4 12 4 10.8954 4.89543 10 6 10 7.10457 10 8 10.8954 8 12ZM20 12C20 13.1046 19.1046 14 18 14 16.8954 14 16 13.1046 16 12 16 10.8954 16.8954 10 18 10 19.1046 10 20 10.8954 20 12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLateralityIndicator is a generated icon component.
 */
let IconMedLateralityIndicator = IconMedLateralityIndicator_1 = class IconMedLateralityIndicator extends IconBaseElement {
    render() {
        return html `${IconMedLateralityIndicator_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLateralityIndicator.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLateralityIndicator = IconMedLateralityIndicator_1 = __decorate([
    customElement('zui-icon-med-laterality-indicator')
], IconMedLateralityIndicator);
export { IconMedLateralityIndicator };
